import React from 'react';
import classnames from 'classnames';
import { observer } from 'mobx-react';
import { useHistory, useLocation } from 'react-router-dom';
import SidebarItem from 'layout/MainLayout/SidebarItem';
import { useStores } from 'hooks';
import style from './Sidebar.module.scss';
import useSidebar from './useSidebar';

export default observer(({ isSidebarOpen, setIsSidebarOpen, isMobile }) => {
  const { authStore } = useStores();
  const history = useHistory();
  const location = useLocation();

  const paths = ['/account_management'];

  const isActive = paths.some((_path) => location.pathname.includes(_path));

  const onLogout = () => {
    authStore.logoutAll();
  };

  const toggleSidebar = () => {
    setIsSidebarOpen((prevState) => !prevState);
  };

  const onClickAccountManagement = () => {
    isMobile && toggleSidebar();
    history.push('/account_management');
  };

  const sidebarItemGroups = useSidebar();

  return (
    <div className={classnames(style.sidebar, { [style.closed]: !isSidebarOpen })}>
      <div className={classnames(style.logo)} />
      <div className={style.header}>
        <h4 className={style.title}>
          AMAZ Global Limited
        </h4>
        <div className="pointer right mobile-only position-absolute mr-3 mt-3" onClick={toggleSidebar}><i className="fas fa-times h1" /></div>
      </div>
      <div onClick={toggleSidebar} className={classnames(style.toggler, { [style.closed]: !isSidebarOpen })}>
        <i className={classnames('fas fa-play', { 'fa-rotate-180': isSidebarOpen })} />
      </div>
      <div className={style.content}>
        {sidebarItemGroups.map((sidebarItems, i, arr) => (
          <div key={`sidebargroup-${i}`}>
            {sidebarItems.map((item) => (
              <SidebarItem
                isSidebarOpen={isSidebarOpen}
                key={`${item.name}-${item.path}`}
                {...item}
                isMobile={isMobile}
                toggleSidebar={toggleSidebar}
              />
            ))}
            {i < arr.length - 1 && <hr className={style.hr} />}
          </div>
        ))}
        <div className={classnames(style.actionBock, { [style.closed]: !isSidebarOpen })}>
          <div className={classnames(style.drawerItem, { [style.active]: isActive })} onClick={onClickAccountManagement}>
            <div className={style.drawerIconWrapper} style={{ paddingTop: 0 }}>
              <div className={style.userProfile} style={{ backgroundImage: `url(${authStore.viewer.avatar || 'https://static.amaz.xyz/emoji/AMAZ+Icon_User.png'})` }} />
            </div>
            <div className={style.drawerItemText}>
              {authStore.viewer.username}
            </div>
          </div>
          <div className={style.drawerItem} onClick={onLogout}>
            <div className={style.drawerIconWrapper}>
              <i style={{ left: '5px' }} className={`fas fa-sign-out-alt ${style.drawerItemIcon}`} />
            </div>
            <div className={style.drawerItemText}>Logout</div>
          </div>
        </div>
      </div>
    </div>
  );
});
